import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AirlinesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"airlines"}/>
}
